import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inconsolata\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inconsolata\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SandpackCSS"] */ "/app/src/app/sandpack-styles.tsx");
